import { Suspense, lazy } from "react";
import { useRoutes } from "react-router-dom";
import LoadingScreen from "../pages/LoadingScreen";

const Loadable = (Component) => (props) => {
  return (
    <Suspense fallback={<LoadingScreen />}>
      <Component {...props} />
    </Suspense>
  );
};

const Home = Loadable(lazy(() => import("../pages/Home")));
const Legal = Loadable(lazy(() => import("../pages/Legal")));
const Contact = Loadable(lazy(() => import("../pages/Contact")));
const Games = Loadable(lazy(() => import("../pages/Games")));
const Game = Loadable(lazy(() => import("../pages/Game")));
// const SayCheese = Loadable(lazy(() => import("../pages/SayCheese")));
const Malhaar = Loadable(lazy(() => import("../pages/Malhaar")));
const NotFound = Loadable(lazy(() => import("../pages/Page404")));

const Router = () => {
  return useRoutes([
    {
      path: "/",
      element: <Home />,
    },
    {
      path: "/legal",
      element: <Legal />,
    },
    {
      path: "/contact",
      element: <Contact />,
    },
    {
      path: "/games",
      element: <Games />,
    },
    {
      path: "/games/:name",
      element: <Game />,
    },
    // {
    //   path: "/SayCheese",
    //   element: <SayCheese />,
    // },
    {
      path: "/Malhaar",
      element: <Malhaar />,
    },
    { path: "*", element: <NotFound /> },
  ]);
};

export default Router;
